import { axiosInstance as request } from '@/api/rest.service'

export const getColumns = () => request.get('/research-output/articles/validation/columns')
export const getRows = params => request.get('/research-output/articles?paginated=true', { params })
export const updateArticle = (id, newVal) =>
  request.patch(`/research-output/articles/${id}`, {
    is_approved: newVal
  })
export const deleteArticle = id => request.delete(`/research-output/articles/${id}`)
export const getStats = () => request.get('/research-output/articles/validation/stats')
